import styles from "@css/modules/ResortSections.module.scss"
import { SlideAppear } from "../../../Animation/SlideAppear"

export function RestaurantsHeader({ title, description, background }) {
    const backgroundImage = `url(${background.formats.large.url})`
    return (
        <SlideAppear className={styles.restaurantsHeader}>
            <div style={{ backgroundImage }} className={styles.restaurantsHeaderBg} />
            <div className={styles.restaurantsTitle}>{title}</div>
            <div className={styles.restaurantsDescription}>{description}</div>
        </SlideAppear>
    )
}
